import React, { ReactNode, useState } from 'react';
import styles from './assets/screen.module.scss';
import classNames from 'classnames';
import SeanceReportsGrid from './components/SeanceReportsGrid';
import { Paginated } from 'src/services/api-handlers/pagination';
import { QueryParams } from 'src/types/grid';
import RoleLayout from 'src/components/layout/RoleLayout';
import { ISeanceReport } from '../../../../../types/seanceReport';
import Loader from '../../../../../components/Loader';
import user from '../../../../../services/user-auth';
import UserRole from '../../../../../enumerables/user-role';
import { IServiceType } from '../../../../../types/service-types';

export interface StateProps {
    data: Paginated<ISeanceReport>;
    providers: SelectObject[];
    students: SelectObject[];
    totals: any;
    inProgress: boolean;
    serviceTypes?: Paginated<IServiceType>;
}

export interface DispatchProps {
    getData: (params: QueryParams) => void;
    getDataTotal: (params: QueryParams) => void;
    getProviders: (params: QueryParams) => void;
    getStudents: (params: QueryParams) => void;
    clearTotal: () => void;
    getDataCsv: (params: QueryParams) => void;
    getServiceTypes: (params: QueryParams) => void;
}

export interface OwnProps {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

class SeanceReportList extends React.Component<Props, { isTotal: boolean; filters: any }> {
    constructor(props: Props) {
        super(props);
        this.state = {
            isTotal: false,
            filters: {},
        };
        this.getData = this.getData.bind(this);
    }
    componentDidMount() {
        this.props.getProviders({
            page: 1,
        });
        this.props.getStudents({
            page: 1,
        });
    }
    componentWillUnmount() {
        this.setState({ isTotal: false });
        this.props.clearTotal();
    }

    getData(data: any) {
        if (data.filters) {
            this.setState({ ...this.state, filters: data.filters });
        }
        if (!this.state.isTotal) {
            data.notTotal = true;
        }
        this.props.getData({ ...data, page: data.page ? data.page : 1 });
    }

    public render(): ReactNode {
        const { getDataCsv, providers, students, inProgress, serviceTypes } = this.props;
        const isProvider = user.getRoles().includes(UserRole.ROLE_USER);
        const isSupervisor = user.getSupervisor();

        return (
            <RoleLayout>
                {isProvider && !isSupervisor ? null : <div className={'isGetCsv'}></div>}
                <div className={classNames(styles.pageHeading, 'pageHeading')}>
                    <h2 className={classNames(styles.pageHeadingTitle, 'pageHeadingTitle')}>
                        BILLED HOURS REPORT {this.props.data.totalCount ? '(' + this.props.data.totalCount + ')' : ''}
                    </h2>
                </div>
                <div className={classNames(styles.list)}>
                    {inProgress ? <Loader /> : null}
                    <SeanceReportsGrid
                        serviceTypes={serviceTypes}
                        providers={providers}
                        students={students}
                        getDataCsv={getDataCsv}
                        data={this.props.data}
                        getData={this.getData}
                    />
                </div>
            </RoleLayout>
        );
    }
}

export default SeanceReportList;
